<!--
 * @FileDescription: 热搜词
 * @Author: 陈文景
 * @Date: 2023-02-24 14:59:35
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="container">
    <el-tabs v-model="active" @tab-click="onClickTabs">
      <el-tab-pane label="使用中" name="using">
        <Using ref="using" />
      </el-tab-pane>
      <el-tab-pane label="已弃用" name="deprecate">
        <Deprecate ref="deprecate" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Using from './components/Using.vue'
import Deprecate from './components/Deprecate.vue'

export default {
  name: 'operation_hotsearch',
  components: {
    Using,
    Deprecate
  },
  data() {
    return {
      active: 'using'
    }
  },
  mounted() {
    this.$refs.using.getHotsearchList()
  },
  methods: {
    /**
     * 切换Tab时的回调
     */
    onClickTabs() {
      // 使用中
      if (this.active === 'using') {
        this.$refs.using.getHotsearchList()
      }
      // 已弃用
      if (this.active === 'deprecate') {
        this.$refs.deprecate.getHotsearchList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  padding: 12px;
  background-color: #fff;
  .el-tabs {
    height: 100%;
    /deep/.el-tabs__content {
      height: calc(100% - 53px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
}
</style>
